import React, { useEffect, useRef } from "react"
import { Animated, Easing } from "react-native"

/**
 * Les questions suivantes d'un compositeur, révélées une fois la première
 * renseignée : le parent découvre l'écran par paliers au lieu de le prendre
 * en bloc. Rien n'est monté tant que `visible` est faux.
 */
const FunnelReveal = ({ visible, children }) => {
    const reveal = useRef(new Animated.Value(visible ? 1 : 0)).current
    useEffect(() => {
        Animated.timing(reveal, {
            toValue: visible ? 1 : 0,
            duration: 300,
            easing: Easing.out(Easing.cubic),
            useNativeDriver: true,
        }).start()
    }, [visible])

    if (!visible) return null
    return <Animated.View style={{ opacity: reveal }}>{children}</Animated.View>
}

export default FunnelReveal
